/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import _ from "lodash";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { ProcessQResponseMessage } from "../../../messages";

export const checkIfDataChanged = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    const message: ProcessQResponseMessage = context?.message;
    const storageService = StorageModule.getInstance();
    try {
      const qStore = storageService.get("io.vlinder.activeQStore", "memory");
      if (!qStore) {
        console.log(`initial request, format the packets`);
        message.isDataChanged = true;
        return resolve(true);
      }
      if (_.isEqual(message?.raw?.parsed, qStore)) {
        message.isDataChanged = false;
        console.log(`no change in data, ignore the packets`);
        return reject(`no change in data, ignore the packets`);
      }
      console.log(`data changes, format the packets`);
      message.isDataChanged = true;
      return resolve(true);
    } catch (err: any) {
      console.log(`error in checkIfDataChanged error=${err?.message}`);
      return reject(err?.message);
    }
  });
};
